import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Blog.css';

const BlogPreview = () => {
  const { t } = useTranslation();
  const blogPosts = t('blog.posts', { returnObjects: true }) || [];
  const defaultTitles = [
    'Autoexame: por que ele veio para ficar?',
    'HPV: tudo o que você precisa saber',
    'Depoimentos de mulheres que venceram o medo'
  ];
  const previewItems = [
    { src: '/images/dep_01.png', webp: '/images/dep_01.webp' },
    { src: '/images/dep_02.png', webp: '/images/dep_02.webp' },
    { src: '/images/dep_03.png', webp: '/images/dep_03.webp' }
  ].map((item, index) => ({
    src: item.src,
    webp: item.webp,
    alt: blogPosts[index]?.title || defaultTitles[index],
    title: blogPosts[index]?.title || defaultTitles[index]
  }));
  return (
    <section className="blog blog-preview">
      <div className="container">
        <div className="blog-header" data-aos="fade-up">
          <h2 className="blog-title">{t('blog.title')}</h2>
          <Link to="/blog" className="blog-link">{t('blog.verMais')}</Link>
        </div>
        <div className="blog-preview-row">
          {previewItems.map((item, idx) => (
            <Link to="/blog" className="blog-preview-img-wrap" key={idx} title="Ver blog">
              <div className="blog-preview-card">
                <picture>
                  <source type="image/webp" srcSet={item.webp} />
                  <img src={item.src} alt={item.alt} className="blog-preview-img" />
                </picture>
                <div className="blog-preview-title">{item.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
